import loadAuthenticationModule from './modules/Authentication.module';
import loadSessionModule from './modules/Session.module';
const loadAccountMenuItemModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule(), loadAuthenticationModule()],
});
export default loadAccountMenuItemModule;
